module.exports = __webpack_public_path__ + "static/img/pic_azh_szhzx_zdfw.563db1b9.png";